import React, { FC } from 'react';
import { ProgressBarRound20 } from '@carbon/icons-react';

export const AnimatedSaveProgress: FC = () => (
    <span className="animate-fade mr-2">
        <ProgressBarRound20 className=" text-white animate-spin" />
    </span>
);
